<app-lfsa-card-v2 *ngIf="!mostrarFormulario" [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplate"
                  [modulo]="DAT_TITULOS.modulo" [tituloCard]="titulo" [titulo]="DAT_TITULOS.titulo">
</app-lfsa-card-v2>
<ng-template #innTemplateButton>
  <div class="col-md-6">
    <div class="pagetitle">
      <div class="btn-group-justified btn-group" style="float: right;">
        <a (click)="nuevo()" class="btn btn-outline-success">
          <span class="fa fa-plus"></span>
          {{ DAT_TITULOS.nuevo }}
        </a>
        <a class="btn btn-outline-warning btn-outline"><i class="far fa-file-excel"></i></a>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #enviarTemplate>
  <!-- <br> -->
  <section class="section">
    <div class="row">
      <div class="col-md-12 ">
        <app-lfsa-alerts [listaVacia]="listaVacia" [loading]="loading" [texto]="DAT_TITULOS.listaVacia">
        </app-lfsa-alerts>
        <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" *ngIf="!listaVacia"
                         [columnDefs]="columnDefs" [floatingFilter]="true" [frameworkComponents]="frameworkComponents " [localeText]="AG_GRID_LOCALE_ES"
                         [pagination]="true"
                         [rowData]="rowData" [rowSelection]="rowSelection" [style]="modulo.agGrid.style"
                         class="ag-theme-alpine" [paginationPageSize]="modulo.agGrid.paginacion">
        </ag-grid-angular>
      </div>
    </div>
  </section>
</ng-template>

<app-lfsa-card-v2 *ngIf="mostrarFormulario" [innTemplate]="enviarTemplateForm" [modulo]="DAT_TITULOS.modulo"
                  [tituloCard]="titulo" [titulo]="DAT_TITULOS.titulo">
</app-lfsa-card-v2>
<ng-template #enviarTemplateForm>
  <form [formGroup]="formulario" class="form-group" novalidate>
    <div class="row">
      <div class="form-group col-md-4 ">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get('equiId')" [id]="'equiId'"
                        [label]="'Equipo ID*'"
                        [placeholder]="'Ingrese Equipo ID'" formControlName="equiId"></app-lfsa-input>
      </div>
      <div class="form-group col-md-4 ">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get('tanqueSerialNumber')" [id]="'tanqueSerialNumber'"
                        [label]="'Serial Number*'"
                        [placeholder]="'Ingrese Serial Number'"
                        formControlName="tanqueSerialNumber"></app-lfsa-input>
      </div>
      <div class="form-group col-md-4 ">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get('tanqueDescripcion')" [id]="'tanqueDescripcion'"
                        [label]="'Descripcion*'"
                        [placeholder]="'Ingrese Descripción'"
                        formControlName="tanqueDescripcion"></app-lfsa-input>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-6 ">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get('tanqueCapacidad')" [id]="'tanqueCapacidad'"
                        [label]="'Capacidad*'"
                        [placeholder]="'Ingrese Capacidad'"
                        formControlName="tanqueCapacidad"></app-lfsa-input>
      </div>
      <div class="form-group col-md-6 ">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get('tanqueDensidad')" [id]="'tanqueDensidad'"
                        [label]="'Densidad*'"
                        [placeholder]="'Ingrese Densidad'" formControlName="tanqueDensidad"></app-lfsa-input>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-6">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [comboBox]="cmbClientes"
                            [control]="formulario.get('cliente')" [idOpcion]="'cliId'" [id]="'cliente'"
                            [label]="'Cliente*'"
                            [opcion]="'cliNombre'" formControlName="cliente"></app-lfsa-combo-box>
      </div>
      <div class="form-group col-md-6">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [comboBox]="cmbArticulos"
                            [control]="formulario.get('articulo')" [idOpcion]="'artId'"
                            [id]="'articulo'" [label]="'Articulo*'"
                            [opcion]="'artDescripcion'" formControlName="articulo"></app-lfsa-combo-box>
      </div>
    </div>
    <br>
    <app-lfsa-botones-formulario (devolverAccion)="acciones ( $event )" [formularioValido]="formulario.invalid"
                                 [textBoton]="textBoton"></app-lfsa-botones-formulario>
  </form>
</ng-template>
